import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import ActionButtons from '../ActionButtons';
import CustomCard from '../CustomCard/CustomCard';
import { InfoCardProps } from './InfoCardTypes';

const InfoCard: React.FC<InfoCardProps> = ({
  icon,
  title,
  subheader,
  infoText,
  hintText,
  onCreate,
  onDeleteSelected,
  children,
}) => (
  <CustomCard icon={icon} title={title} subheader={subheader} sx={{ mb: 4 }}>
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" gutterBottom>
        {infoText}
      </Typography>
      {hintText && (
        <Typography variant="body2" color="text.secondary">
          {hintText}
        </Typography>
      )}
    </Box>
    {(onCreate || onDeleteSelected) && (
      <ActionButtons onCreate={onCreate} onDeleteSelected={onDeleteSelected} />
    )}
    {children}
  </CustomCard>
);

export default InfoCard;
